<template>
    <div>
        <div class="progress progresso-top" :class="{'hide':pilha.length == 0}">
            <div class="indeterminate"></div>
        </div>
        <div class="overlay" :class="{'hide':pilha.length == 0}"></div>
    </div>
</template>
<script>
export default {
    name:'top-loader',
    props: {
        pilha:{type:Array, required:true}
    },
    data() {
        return {
        }
    }
}

</script>
<style>
  .overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(255,255,255,0.1);
    z-index: 10000;
  }
</style>



// WEBPACK FOOTER //
// TopLoader.vue?26897d25